// extracted by mini-css-extract-plugin
export var deliveryRow = "_mu-a";
export var fixedHeight = "_mu-4";
export var freightLogo = "_mu-9";
export var fullWidth = "_mu-3";
export var priceColumn = "_mu-5";
export var radioSelected = "_mu-7";
export var radioUnselected = "_mu-6";
export var selectedOption = "_mu-2";
export var selectedOptionContainer = "_mu-1";
export var selection = "_mu-0";
export var tallSkeletonText = "_mu-8";